<div class="calendarDaySection" (click)="createReminder()">
  <div class="calendarReminders__time">
    {{ displayDate }}
  </div>

  <section class="calendarReminders">
    @for (reminder of reminders; track reminder) {
      <pp-reminder-calendar-element
        [ppReminder]="reminder"
        [ppDailyView]="true"
      ></pp-reminder-calendar-element>
    }
  </section>
</div>
